import { StylesProvider } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import 'raleway-webfont';
import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider as StoreProvider, useSelector } from 'react-redux';

import { IColorMap, colorsSelector } from 'reducers/app.reducer';
import theme from 'theme';
import App from './app';
import SnackMessage from './components/layouts/SnackMessage';
import './i18n';
import * as serviceWorker from './serviceWorker';
import store from './store';
import { ThemeProvider } from './ThemeProvider';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const AppWithCustomThemeFromBO = () => {
  const {
    primary: mainColorFromBO,
    secondary: secondaryColorFromBO,
    tertiary: tertiaryColorFromBO,
    accent: primaryColorFromBO,
  }: IColorMap = useSelector(colorsSelector);

  const customTheme = theme({
    primaryColorFromBO,
    secondaryColorFromBO,
    tertiaryColorFromBO,
    mainColorFromBO,
  });

  if (process.env.NODE_ENV === 'development') {
    // usefully display theme in console for easier development
    const style = `
      background-color: black;
      color: lime;
      font-size: 2em;
      padding: 0.5em 1em;
    `;
    /* eslint-disable no-console */
    console.group('%c*********** Mui THEME ********', style);
    console.log(
      theme({
        primaryColorFromBO,
        secondaryColorFromBO,
        tertiaryColorFromBO,
        mainColorFromBO,
      }),
    );
    console.log('%c*****************************', style);
    console.groupEnd();
    /* eslint-enable no-console */
  }

  return (
    <React.Fragment>
      <ThemeProvider theme={customTheme}>
        <SnackbarProvider
          preventDuplicate
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          content={(key: string | number, message: string) => (
            <SnackMessage id={key} message={message} />
          )}
        >
          <App />
        </SnackbarProvider>
      </ThemeProvider>
    </React.Fragment>
  );
};

ReactDOM.render(
  <StylesProvider injectFirst>
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <StoreProvider store={store}>
          <AppWithCustomThemeFromBO />
        </StoreProvider>
      </QueryClientProvider>
    </CookiesProvider>
  </StylesProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
